/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  DxContextMenuModule,
  DxPopupModule,
  DxProgressBarModule,
  DxSelectBoxModule,
  DxTemplateModule,
  DxTooltipModule,
} from 'devextreme-angular';
import { CategoryScopeComponent } from './category-scope.component';
import { SysqueTooltipModule } from '../../../../../../shared/ui/src/lib/components/sysque-tooltip';
import { AddFittingBtnModule } from '../add-fitting-btn';
import { SysqueAlertModule } from '../../../../../../shared/ui/src/lib/components/sysque-alert';
import { SysqueProgressBarModule } from '../../../../../../shared/ui/src/lib/components/sysque-progress-bar';
import { SysqueContextMenuModule } from '../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { SysqueGaugeTakeOffServiceModule } from './sysque-gauge-take-off-service';

@NgModule({
  declarations: [CategoryScopeComponent],
  imports: [
    CommonModule,
    FormsModule,
    DxContextMenuModule,
    DxSelectBoxModule,
    DxTemplateModule,
    DxProgressBarModule,
    DxPopupModule,
    SysqueTooltipModule,
    AddFittingBtnModule,
    SysqueAlertModule,
    SysqueProgressBarModule,
    SysqueContextMenuModule,
    SysqueGaugeTakeOffServiceModule,
    DxTooltipModule
  ],
  exports: [CategoryScopeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CategoryScopeModule {}
